import {apiDomain} from "../config"
import getAPI from "../baseGetAPI";

function getMerchantByMidAPI(mid, successCallback, failCallback){
    getAPI(`${apiDomain}merchant/${mid}`, successCallback, failCallback);
}

export default getMerchantByMidAPI;
